import React from "react";
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  BooleanInput,
  BooleanField
} from "react-admin";
import Grid from '@material-ui/core/Grid';

export const AuditorFilter = props => (
  <Filter {...props}>
    <TextInput label="Nombre" source="searchnombre" alwaysOn />
    <TextInput label="Usuario o dni" source="searchdni" />
    <BooleanInput label="habilitado" source="habilitado" />
  </Filter>
);

const AuditorNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Auditor</span>}
      medium={
        <span>Editar Auditor: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

export const AuditorEdit = props => (
  <Edit title={<AuditorNameEdit />} {...props}>
    <SimpleForm>
      <Grid container direction="row" item xs={10}>
        <Grid container direction="column" item xs={10} sm={6}  style={{paddingRight: 80}}>
          <TextInput label="Nombre y Apellido" source="nombre" />
          <TextInput label="Usuario o dni" source="dni" />
          <BooleanInput label="Habilitar" source="habilitado" />
          <TextInput label="Contraseña" source="validacion" type="password" />
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
);

export const AuditorCreate = props => (
  <Create {...props} title="Registrar Auditor">
    <SimpleForm redirect="/auditores">
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="Usuario o dni" source="dni" />
      <BooleanInput label="Habilitar" source="habilitado" />
      <TextInput label="Contraseña" type="password" source="validacion" />
    </SimpleForm>
  </Create>
);

export const EditableAuditorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<AuditorFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField source="dni" label="Usuario/dni" />
          <BooleanField source="habilitado" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const AuditorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<AuditorFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      medium={
        <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" label="Usuario/dni" />
          <BooleanField source="habilitado" />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/auditores.js